/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-08 17:17:16
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-08-12 20:10:03
 * @FilePath: /partner.chaoyongtuan.com/src/modules/sample/apply/rules/filter.js
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
 */
import { confs } from './dataMap';
export const unitFormat = value => {
	let val = Number(value);
	if (val >= 10 ** 4) return `${Math.round((val / 10 ** 4) * 100) / 100}w`;
	else return val;
};
export const formatSampleRule = (val, platformId) => {
	const textConf = { fans_num: '粉丝量', ...confs[+platformId] };
	const { outer_product_id, anchor_ids, ...rest } = val;
	const txt = Object.keys(rest).reduce((total, cur) => {
		return `${total}${textConf[cur]}≥${['sales','fans_num'].includes(cur) ? unitFormat(val[cur]) : `¥${unitFormat(val[cur])}`}`;
	}, '');
	return txt;
};

export const formatSampleRulePopover = (val, platformId) => {
	const textConf = { fans_num: '粉丝量', ...confs[+platformId] };
	const { outer_product_id, anchor_ids, ...rest } = val;
	const txt = Object.keys(rest).map(cur => `${textConf[cur]}≥${['sales','fans_num'].includes(cur) ? unitFormat(val[cur]) : `¥${unitFormat(val[cur])}`}`);
	return txt;
};
